export default __webpack_public_path__ + "static/media/Nav.2e2a605d.png";